import { computed } from 'vue';
import { useStore } from 'vuex';
import type { GetCrmMiscMetricsResponses } from '@/types/openapi-ts';

type CrmMetricItem = GetCrmMiscMetricsResponses[200]['payload'][number];

export const useCrmMetrics = () => {
  const store = useStore();

  const crmMetrics = computed<CrmMetricItem[]>(() => store.getters['crm/crmMetrics'] || []);
  const pCrmMetrics = computed(() => {
    return crmMetrics.value.map((item) => ({
      ...item,
      name: item.column_name,
      items: [],
    }));
  });
  const crmMetricGroups = computed(() => ([{
    group_name: '',
    items: pCrmMetrics.value,
  }]));
  const metricsIndex = computed(() => {
    const result: Record<string, CrmMetricItem> = {};
    pCrmMetrics.value.forEach((item) => {
      result[item.column_name] = item;
    });
    return result;
  });

  return {
    crmMetrics,
    pCrmMetrics,
    crmMetricGroups,
    metricsIndex,
  };
};
